import React from 'react'
import Headline from '../atoms/Headline'
import CustomArticleStackedTeaser from '../atoms/CustomArticleStackedTeaser'
import SbEditable from 'storyblok-react'
import Slider from 'react-slick'

const CustomArticleTripleTeaserBlock = ({ block, className }) => {
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    mobileFirst: true,
    infinite: false,
    appendDots: (dots) => <ul> {dots} </ul>,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <SbEditable content={block}>
      <section
        className={`triple-teaser-block article-triple-teaser-block ${className} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="triple-teaser-block-container">
          <div
            className="triple-teaser-block-wrapper"
            data-rellax-center={true}
            data-rellax-speed={-1}
          >
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
            />
            <Slider
              className={`triple-teaser-block-row ${
                block.double_teaser && block.double_teaser === true
                  ? 'double-teaser'
                  : 'triple-teaser'
              } article-triple-teaser-block-row justify-content-start`}
              {...settings}
            >
              {block.teaser?.length > 0 &&
                block.teaser.map((item, index) => (
                  <CustomArticleStackedTeaser item={item} key={index} />
                ))}
            </Slider>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default CustomArticleTripleTeaserBlock
